import { render } from "./Main.vue?vue&type=template&id=596bc485"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=596bc485&lang=css"

import exportComponent from "/n/www/reich-ages.rc.hms.harvard.edu/AGES/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__